/* merkWuerdig MW-008 - Mega-Menue: Hoehe nachziehen (Horizon 4.2.0)
   WAS:    Haelt --full-open-header-height am Header mit --submenu-height in Sync und
           misst das offene Untermenue nach, wenn sich seine Hoehe aendert.
   WARUM:  Horizon laedt die Produktkarten im Mega-Menue nachtraeglich (Section Rendering API).
           header-menu.js aktualisiert danach nur --submenu-height, nicht --full-open-header-height.
           Folge: Untermenue verschoben, oben abgeschnitten, Karten ragen unten ueber die Flaeche
           hinaus (Lars, 21.09.2026: "im Menue ist irgendwas kaputt").
   WIE:    Beobachtet nur Style-Attribut und Groesse; setzt dieselben Variablen wie das Theme.
   SEIT:   21.09.2026
   ENTFERNBAR WENN: Horizon #setFullOpenHeaderHeight auch im MutationObserver aufruft
           (assets/header-menu.js) - dann Datei loeschen und Zeile in snippets/mw-styles.liquid entfernen. */
(function () {
  var header = document.getElementById('header-component');
  if (!header) return;
  var px = function (name) { return parseFloat(header.style.getPropertyValue(name)) || 0; };
  var sichtbar = function () {
    var top = header.querySelector('.header__row--top');
    return header.hasAttribute('data-submenu-overlap-bottom-row') && top ? top.offsetHeight : header.offsetHeight;
  };
  var setze = function (sub) {
    var soll = sub + sichtbar();
    if (Math.abs(px('--submenu-height') - sub) >= 1) header.style.setProperty('--submenu-height', sub + 'px');
    if (Math.abs(px('--full-open-header-height') - soll) >= 1) header.style.setProperty('--full-open-header-height', soll + 'px');
  };
  var offenes = function () {
    return Array.prototype.filter.call(header.querySelectorAll('.menu-list__submenu'), function (s) { return s.inert === false && s.offsetHeight > 0; })[0];
  };
  var sync = function () {
    if (!px('--submenu-height') || !px('--full-open-header-height')) return; // Menue zu
    var sub = offenes();
    if (sub) setze(sub.offsetHeight);
  };
  new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['style'] });
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var s = e.target;
        if (s.inert === false && s.offsetHeight > 0 && px('--full-open-header-height') > 0) setze(s.offsetHeight);
      });
    });
    var beobachte = function () { header.querySelectorAll('.menu-list__submenu').forEach(function (s) { ro.observe(s); }); };
    beobachte();
    new MutationObserver(beobachte).observe(header, { childList: true, subtree: true });
  }
})();
